import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FaleconoscoService } from '../../providers/faleconosco.service';
import { FormGroup } from '@angular/forms';
import swal from 'sweetalert2';
import { UtilService } from '../../providers/util.service';

@Component({
  selector: 'app-trabalhe-conosco',
  templateUrl: './trabalhe-conosco.component.html',
  styleUrls: ['./trabalhe-conosco.component.scss']
})
export class TrabalheConoscoComponent implements OnInit, OnDestroy {

  listVagas = [];
  sub: Subscription;
  cargo = '';
  isLoading = false;
  curriculo: string;


  constructor(
    private util: UtilService
  ) { }

  ngOnInit() {
   this.sub = this.util.listVagas().subscribe(data => this.listVagas = data.linhas);
  }

  uploadCurriculo($event) {
    this.curriculo = $event;
  }

  postForm(form: FormGroup) {

    const values = form.value;
    values['arquivo'] = this.curriculo;
    this.isLoading = true;

    this.sub = this.util.postCurriculo(values).subscribe(
      data => { 
        this.util.callAlert('OK', 'Seu currículo foi enviado com sucesso!', 'success');
        setTimeout(() => {
          this.isLoading = false; 
        }, 2000);
        form.reset();
      },
      err => {
        setTimeout(() => {
          this.isLoading = false; 
        }, 2000);
        this.util.callAlert('Ops!', 'Ocorreu um erro. Tente novamente!', 'error')
      } 
    );

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
